import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { toast } from "sonner";

import { API, setToken } from "../api";
import { useAuth } from "../auth";

export default function AuthCallback() {
  const nav = useNavigate();
  const { setUser } = useAuth();
  const processed = useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;

    const hash = window.location.hash || "";
    const m = hash.match(/session_id=([^&]+)/);
    if (!m) {
      toast.error("No Google session — please try again");
      nav("/login");
      return;
    }
    const session_id = decodeURIComponent(m[1]);

    (async () => {
      try {
        const r = await axios.post(`${API}/auth/google/exchange`, { session_id });
        const { token, user, first_login } = r.data;
        setToken(token);
        setUser(user);
        // Zero-step onboarding for first Google login:
        // - new user with no cases → create one and go straight to chat
        // - returning user → dashboard
        const cases = await axios.get(`${API}/cases`, {
          headers: { Authorization: `Bearer ${token}` },
        });
        if (first_login || (cases.data || []).length === 0) {
          const c = await axios.post(`${API}/cases`, {}, {
            headers: { Authorization: `Bearer ${token}` },
          });
          nav(`/cases/${c.data.case_meta.case_id}`, { replace: true });
        } else {
          nav("/dashboard", { replace: true });
        }
      } catch (e) {
        toast.error(e?.response?.data?.detail || "Could not complete Google sign-in");
        nav("/login", { replace: true });
      }
    })();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="min-h-screen flex items-center justify-center bg-[var(--canvas)]" data-testid="auth-callback">
      <div className="text-center">
        <div className="inline-flex items-center gap-2 text-slate-600">
          <span className="infin-typing-dot" />
          <span className="infin-typing-dot" />
          <span className="infin-typing-dot" />
        </div>
        <div className="text-sm text-slate-500 mt-3">Signing you in…</div>
      </div>
    </div>
  );
}
